import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { auth } from '@/firebase';
import { firestorePlugin } from 'vuefire';
import VueMq from 'vue-mq';
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.config.productionTip = false;
Vue.use(CKEditor);
Vue.use(firestorePlugin);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1264,
    desktop: Infinity,
  },
});

var debounceTimeout;
const DebounceDueTime = 200;

auth.onAuthStateChanged(() => {
  if (debounceTimeout) clearTimeout(debounceTimeout);

  debounceTimeout = setTimeout(() => {
    debounceTimeout = null;

    new Vue({
      router,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  }, DebounceDueTime);
});
